"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.THUNKTANK_UNQUEUE = exports.THUNKTANK_ENQUEUE = exports.THUNKTANK_SET_ERROR = exports.THUNKTANK_SET_DATA = exports.THUNKTANK_LOADING = exports.THUNKTANK_RESET = exports.THUNKTANK_REMOVE = exports.THUNKTANK_ADD = exports.THUNKTANK_INIT = void 0;
exports.THUNKTANK_INIT = 'THUNKTANK_INIT';
exports.THUNKTANK_ADD = 'THUNKTANK_ADD';
exports.THUNKTANK_REMOVE = 'THUNKTANK_REMOVE';
exports.THUNKTANK_RESET = 'THUNKTANK_RESET';
exports.THUNKTANK_LOADING = 'THUNKTANK_LOADING';
exports.THUNKTANK_SET_DATA = 'THUNKTANK_SET_DATA';
exports.THUNKTANK_SET_ERROR = 'THUNKTANK_SET_ERROR';
exports.THUNKTANK_ENQUEUE = 'THUNKTANK_ENQUEUE';
exports.THUNKTANK_UNQUEUE = 'THUNKTANK_UNQUEUE';
